import {
  Component,
  Input,
  OnInit,
  signal,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  FollowUp,
  FollowUpsUser,
} from '@app/modules/follow-ups/follow-ups.types';
import { AssignFollowUpsAction } from '@app/modules/follow-ups/store/follow-ups.actions';
import { FollowUpsState } from '@app/modules/follow-ups/store/follow-ups.state';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslatePipe } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import { SelectOptionComponent } from '@shared/components/select/select-option/select-option.component';
import { SelectComponent } from '@shared/components/select/select.component';

@Component({
  selector: 'app-follow-up-set-assignee',
  imports: [
    FormsModule,
    TranslatePipe,
    SelectComponent,
    SelectOptionComponent,
    ReactiveFormsModule,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './follow-up-set-assignee.component.html',
})
export class FollowUpSetAssigneeComponent implements OnInit {
  private store = inject(Store);
  private modalRef = inject(NgbActiveModal);

  @Input() followUps: FollowUp[];
  protected users: FollowUpsUser[] = [];

  assigneeFormControl = new FormControl<string>('');

  loading = signal(false);

  ngOnInit() {
    this.users = this.store.selectSnapshot(FollowUpsState.getFollowUpsUsers);
    this.assigneeFormControl.setValue(this.followUps[0].assignee);
  }

  close() {
    this.modalRef.close();
  }

  submit() {
    this.loading.set(true);
    this.store
      .dispatch(
        new AssignFollowUpsAction(
          this.followUps.map((followUp) => followUp.id),
          this.assigneeFormControl.value
        )
      )
      .subscribe(() => {
        this.loading.set(false);
        this.modalRef.close();
      });
  }
}
